import React, { useEffect, useState } from 'react';
import {Box, Card, CardContent, TextField, InputAdornment, SvgIcon, makeStyles, Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow} from '@material-ui/core';
import Page from 'src/components/Page';
import PropTypes from 'prop-types';
import { Search as SearchIcon } from 'react-feather';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { WorkerDemanderService } from "../../../services";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  otherButton: {
    marginBottom: theme.spacing(3)
  },
}));



/******************* TOOLBAR *******************/
const Toolbar = ({ className, ...rest }) => {
    const classes = useStyles();
  
    return (
    <div>
        <Button className={classes.otherButton} color="primary" variant="outlined">Add New Client</Button>

        <Card>
            <CardContent>
                <Box maxWidth={500}>
                <TextField fullWidth InputProps={{startAdornment: (
                        <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                        </SvgIcon>
                        </InputAdornment>
                    )
                    }} placeholder="Search (worker demander names,  ..)" variant="outlined"/>
                </Box>
            </CardContent>
        </Card>
    </div>
    );
  };
  
Toolbar.propTypes = {
  className: PropTypes.string
};
/******************* TOOLBAR *******************/



/******************** RESULTS ******************/
const Results = ({ className, registeredClients, ...rest }) => {
    const classes = useStyles();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [workerId, setWorkerId] = useState(0);
    const handleLimitChange = (event) => { setLimit(event.target.value); };
    const navigate =useNavigate();
  
    const handlePageChange = (event, newPage) => {
      setPage(newPage);
    };

    const handleClickOpen = (clientId) => {
      navigate('/app/work_requests/' + clientId, { replace: true });
    };
  
    return (
    <Card>
        <PerfectScrollbar>
            <Box minWidth={1050}>
            <Table>
            <TableHead>
                  <TableRow>
                    <TableCell style={{width: "5%"}}>#</TableCell>
                    <TableCell style={{width: "15%"}}>Firm</TableCell>
                    <TableCell style={{width: "15%"}}>Authorized Person</TableCell>
                    <TableCell style={{width: "15%"}}>Phone</TableCell>
                    <TableCell style={{width: "15%"}}>Email Address</TableCell>
                    <TableCell style={{width: "35%"}}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {registeredClients.slice(page * limit, page * limit + limit).map((registeredClient) => (
                  <TableRow hover key={registeredClient.id}>
                    <TableCell >{registeredClient.id}</TableCell>
                    <TableCell >{registeredClient.firmName}</TableCell>
                    <TableCell >{registeredClient.firstName} {registeredClient.lastName}</TableCell>
                    <TableCell >{registeredClient.mobilePhoneNumber}</TableCell>
                    <TableCell >{registeredClient.emailAddress}</TableCell>
                    <TableCell >
                      <Button variant="outlined" style={{ marginRight: 10 }} onClick={() => { handleClickOpen(registeredClient.id); }}>Requested Works</Button>
                      <Button variant="outlined" onClick={() => { navigate('/app/worker_demander_profile/' + registeredClient.id, { replace: true }); }}>View / Edit</Button>
                    </TableCell>
                  </TableRow>
                  ))}
                </TableBody>
            </Table>
            </Box>
        </PerfectScrollbar>
        <TablePagination component="div" 
            count={registeredClients.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 50, 100]} />
    </Card>
    );
  };
  
Results.propTypes = {
    className: PropTypes.string,
    registeredClients: PropTypes.array.isRequired
};
/******************** RESULTS ******************/

const RegisteredClients = () => {
  const classes = useStyles();
  const [registeredClients, updateRegisteredClients] = useState([]);

  useEffect(function effectFunction(){
    WorkerDemanderService.GET_REGISTERED_CLIENTS()
    .then(({data}) =>{  
      updateRegisteredClients(data.data);         
    })
    .catch((error) => {
      console.log("Registered clients getting failed.");
    }); 
  }, []);    

  return (
    <Page className={classes.root} title="Registered Clients">
      <Toolbar />
      <Results registeredClients={registeredClients} />
    </Page>
  );
};

export default RegisteredClients;
